import { n as e } from "./context-BrD4AniQ.js";
import { i as t, s as n } from "./maplibre-CUYkxr-D.js";
import { n as r, t as i } from "./styles-hx5_Dz4D.js";
import { useEffect as a, useRef as o } from "react";
import { jsx as s } from "react/jsx-runtime";
//#region src/components/Map/Root/Popup/Maptiler/index.tsx
function c({ latitude: c, longitude: l, anchor: u, offset: d = [0, -35], onClose: f, children: p }) {
	let m = o(null), { current: h } = n(), { activeMarker: g, clusterPoints: _, mapPadding: v } = e(), y = o(_), b = o(g);
	return a(() => {
		let e = y.current !== _, t = b.current === g;
		e && t && g !== void 0 && f?.(), y.current = _, b.current = g;
	}, [
		_,
		g,
		f
	]), a(() => {
		let e = m?.current, t = {
			width: 0,
			height: 0
		}, n = () => {
			if (!h || !e || g === void 0) return;
			let n = h.getBounds(), i = h.getCenter(), a = h.getCanvas(), o = e.getElement()?.getBoundingClientRect();
			if (!n || !o) return;
			let s = Math.abs(o.width - t.width), c = Math.abs(o.height - t.height);
			if (t.width !== 0 && s < 15 && c < 15) return;
			t = {
				width: o.width,
				height: o.height
			};
			let l = a.getBoundingClientRect(), u = {
				width: a.clientWidth,
				height: a.clientHeight,
				top: l.top,
				left: l.left
			};
			r(o, {
				latitude: i.lat,
				longitude: i.lng
			}, {
				left: n.getWest(),
				right: n.getEast(),
				top: n.getNorth(),
				bottom: n.getSouth()
			}, u, {
				left: v.left || 0,
				right: v.right || 0,
				top: v.top || 0,
				bottom: v.bottom || 0
			}, (e) => {
				h.easeTo({
					center: [e.longitude, e.latitude],
					duration: 500
				});
			});
		}, i, a = new ResizeObserver(() => {
			i && clearTimeout(i), i = window.setTimeout(() => {
				n();
			}, 100);
		}), o = e?.getElement();
		return o && a.observe(o), () => {
			i && clearTimeout(i), a.disconnect();
		};
	}, [
		h,
		m,
		g,
		v.top,
		v.bottom,
		v.left,
		v.right
	]), c === void 0 || l === void 0 ? null : /* @__PURE__ */ s(t, {
		ref: m,
		className: "maplibre-popup",
		focusAfterOpen: !0,
		latitude: c,
		longitude: l,
		anchor: u,
		offset: d,
		onClose: f,
		closeButton: !1,
		children: /* @__PURE__ */ s("div", {
			className: i,
			children: p
		})
	});
}
//#endregion
export { c as default };
